import React from 'react';

const ResourceCard = ({ resource }) => {
  return (
    <div className="resource-card">
      <a href={resource.resource_url} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
        <img
            src={resource.image_url || "https://firebasestorage.googleapis.com/v0/b/fireup-da7fe.appspot.com/o/resource%20alt.png?alt=media&token=0cede1b6-8c2c-40a7-9c9d-2fb2545bf0c9"}
            alt={resource.name} className="resource-icon"/>
        <div className="resource-info">
          <h3>{resource.name}</h3>
          <p>{resource.description}</p>
          <div className="location-info" style={{ fontWeight: 'bold' }}>{resource.location}</div>
          <span className="resource-tag">{resource.tag}</span>
        </div>
        <div className="contact-info">
          <p><i className="fa-solid fa-globe"></i> <a href={resource.resource_url} target="_blank" rel="noopener noreferrer">{new URL(resource.resource_url).hostname}</a></p>
        </div>
      </a>
    </div>
  );
};

export default ResourceCard;
